import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Button, Flex, Heading, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { AddIcon, EditIcon } from '@chakra-ui/icons';
import { useAsyncApi } from '../../utils/useAsyncApi';
import { getAllOrganizations } from './api';
import { openModal, closeModal, Modals } from '../../redux/reducers';
import EditOrganizationModal from './editOrganizationModal';
import { InfoModal } from '../';

const AllOrganizations = ({ history }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isLoading, response: organizations, error, reload } = useAsyncApi(getAllOrganizations);
  const { showModal, modalProps, modalName } = useSelector((state) => state.ui);

  const openCreateModal = useCallback(() => {
    dispatch(openModal({ createNew: true }, Modals.EDIT_ORGANIZATION));
  }, []);

  return (
    <>
      <EditOrganizationModal
        open={showModal === true && modalName === Modals.EDIT_ORGANIZATION}
        onUpdate={reload}
        {...modalProps}
      />
      <InfoModal
        open={showModal && modalName === Modals.ERROR}
        onRightButtonClick={() => dispatch(closeModal())}
        onClose={() => dispatch(closeModal())}
        leftButtonText={null}
        {...modalProps}
      />
      <Box>
        <Flex>
          <Heading mb="6">{t('organization.all')}</Heading>
          <Button ml="4" onClick={openCreateModal}>
            <AddIcon />
          </Button>
        </Flex>
        {isLoading ? (
          <p>Lataa...</p>
        ) : error ? (
          <p>virhe {error.message || `${error}`}</p>
        ) : (
          <Table>
            <Thead>
              <Tr>
                <Th width="25%">{t('organization.name')}</Th>
                <Th width="50%">{t('organization.description')}</Th>
                <Th>{t('organization.interpreterCount')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {(organizations || []).map((org) => {
                return (
                  <Tr
                    key={org._id}
                    sx={{
                      ':hover': {
                        'bg': '#eee',
                        'cursor': 'pointer',
                        '& .editButton': {
                          display: 'inline',
                        },
                      },
                    }}
                    onClick={() => {
                      history.push(`/organization/${org._id}`);
                    }}
                  >
                    <Td>
                      {org.name}
                      <Button
                        variant="plain"
                        my="-20px"
                        display="none"
                        className="editButton"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(
                            openModal(
                              { createNew: false, organization: org },
                              Modals.EDIT_ORGANIZATION
                            )
                          );
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Td>
                    <Td>{org.description}</Td>
                    <Td>{org.members.length}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )}
      </Box>
    </>
  );
};

AllOrganizations.propTypes = {
  history: PropTypes.object,
};

export default AllOrganizations;
